import { createSelector } from 'reselect';

import type { CasinoIcon, CasinoWidget, MosaicLayout } from '@swf/casino';
import type { CasinoMosaic } from '@swf/cms';
import type { RootState } from '@swf/core/store';
import type { MosaicLocalConfig } from '@swf/core/types/CasinoGame';
import { gamesPerColumn, mosaicIndexRange } from '@swf/core/utils/casino';
import { Service } from '@swf/core/utils/casinoFilters';

export function getIcon() {
  return createSelector(
    (rootState: RootState, config: CasinoWidget) => config,
    (config: CasinoWidget) => config.params?.ims.icon_tags[0] as CasinoIcon
  );
}

export function isFSB() {
  return createSelector(
    (rootState: RootState, config: CasinoWidget) => config,
    (config: CasinoWidget) => !!config.game_service?.match(Service.FreeSpinBonus)
  );
}

export function getLocalConfig() {
  return createSelector(
    (rootState: RootState, config: CasinoMosaic) => config,
    (config: CasinoMosaic): MosaicLocalConfig => {
      const layout = { enabled: true } as MosaicLayout;
      const columnConfigs = mosaicIndexRange.map((i) => {
        const conf = {
          gamesPer: gamesPerColumn((layout[`section_${i}`] = config[`column_${i}`].layout)),
          serviceName: config[`column_${i}`].service
        };
        return conf;
      });

      return { layout, columnConfigs };
    }
  );
}
